import React from "react";

function Experience({ experience: { year, degree, content, isBold } }) {
  return (
    <div className="entry">
      <div className="title">
        <span>{year}</span>
      </div>
      <div className="body">
        <h4 className="mt-0">{isBold ? <strong>{degree}</strong> : degree}</h4>
        <p>{content}</p>
      </div>
    </div>
  );
}

export default Experience;
